'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# OhioDocsSVG
An SVG Ohio Docs icon
 */
var OhioDocsSVG = function OhioDocsSVG(_ref) {
  var color = _ref.color,
      height = _ref.height,
      width = _ref.width;
  return _react2.default.createElement(
    'svg',
    {
      'aria-label': 'Ohio Docs',
      role: 'img',
      height: height || undefined,
      width: width || undefined,
      viewBox: '0 0 75 75',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    _react2.default.createElement(
      'g',
      {
        fill: color,
        fillRule: 'nonzero'
      },
      _react2.default.createElement('rect', {
        x: '21.95',
        y: '45.125',
        width: '23.35',
        height: '2.6'
      }),
      _react2.default.createElement('rect', {
        x: '21.95',
        y: '39.35',
        width: '23.35',
        height: '2.6'
      }),
      _react2.default.createElement('rect', {
        x: '21.95',
        y: '33.6',
        width: '23.35',
        height: '2.6'
      }),
      _react2.default.createElement('rect', {
        x: '21.95',
        y: '51.2',
        width: '23.35',
        height: '2.6'
      }),
      _react2.default.createElement('path', {
        d: 'M37.5,0 C16.8,0 0,16.8 0,37.5 C0,58.2 16.8,75 37.5,75 C58.2,75 75,58.2 75,37.5 C75,16.8 58.2,0 37.5,0 Z M50.4,53 L50.4,57.55 C50.4,60.075 48.35,62.1 45.85,62.1 L21.35,62.1 C18.825,62.1 16.8,60.05 16.8,57.55 L16.8,23.95 C16.8,21.425 18.85,19.4 21.35,19.4 L45.85,19.4 C48.375,19.4 50.4,21.45 50.4,23.95 C50.4,23.95 50.4,28.5 50.4,28.5 L50.4,53 Z M56.25,47.15 L56.25,51.7 C56.25,53.75 54.875,55.5 53,56.05 L53,53 L53,28.5 L53,23.95 C53,20 49.8,16.8 45.85,16.8 L22.825,16.8 C23.4,14.925 25.125,13.55 27.175,13.55 L51.675,13.55 C54.2,13.55 56.225,15.6 56.225,18.1 L56.225,22.65 L56.225,47.15 L56.25,47.15 Z'
      }),
      _react2.default.createElement('rect', {
        x: '21.95',
        y: '27.85',
        width: '23.35',
        height: '2.6'
      })
    )
  );
};

OhioDocsSVG.propTypes = {
  /** a color for the icon */
  color: _propTypes2.default.string,
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string
};

OhioDocsSVG.defaultProps = {
  color: undefined,
  height: undefined,
  width: undefined
};

OhioDocsSVG.displayName = 'OhioDocsSVG';

exports.default = OhioDocsSVG;
OhioDocsSVG.__docgenInfo = {
  'description': '# OhioDocsSVG\r\nAn SVG Ohio Docs icon',
  'methods': [],
  'displayName': 'OhioDocsSVG',
  'props': {
    'color': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'a color for the icon'
    },
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    }
  }
};